import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export var useGetCompanySettings = function (companyId, enabled) {
    if (enabled === void 0) { enabled = true; }
    var intl = useIntl();
    return useQuery([SettingsQueryKey.CompanySettings, companyId], function () {
        return api.base
            .get('/api/settings/Company', { params: { id: companyId } })
            .then(function (res) { return res.data; });
    }, {
        enabled: !!companyId && enabled,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
